import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  interCutVideoList: {
    endZonarData: {
      endZonarDataList: [],
      videoPath: "",
      isPlaying: false,
      playingIndex: null,
    },
    endZonalData: {
      endZonalDataList: [],
      videoPath: "",
      isPlaying: false,
      playingIndex: null,
    },
    wideAngleData: {
      wideAngleDataList: [],
      videoPath: "",
      isPlaying: false,
      playingIndex: null,
    },
    tightAngleData: {
      tightAngleDataList: [],
      videoPath: "",
      isPlaying: false,
      playingIndex: null,
    },
    otherAngleData: {
      otherAngleDataList: [],
      videoPath: "",
      isPlaying: false,
      playingIndex: null,
    },
  },
  totalVideoCount: 0,
  angleCount: 0,
  loading: false,
};

export const IntercutVideoReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_INTERCUT_VIDEO_LIST:
      return {
        ...state,
        interCutVideoList: {
          ...state.interCutVideoList,
          endZonarData: {
            ...state.interCutVideoList.endZonarData,
            endZonarDataList: payload.endZonarData,
            videoPath: payload.endZonarData[0]?.videoPath,
          },
          endZonalData: {
            ...state.interCutVideoList.endZonalData,
            endZonalDataList: payload.endZonalData,
            videoPath: payload.endZonalData[0]?.videoPath,
          },
          wideAngleData: {
            ...state.interCutVideoList.wideAngleData,
            wideAngleDataList: payload.wideAngleData,
            videoPath: payload.wideAngleData[0]?.videoPath,
          },
          tightAngleData: {
            ...state.interCutVideoList.tightAngleData,
            tightAngleDataList: payload.tightAngleData,
            videoPath: payload.tightAngleData[0]?.videoPath,
          },
          otherAngleData: {
            ...state.interCutVideoList.otherAngleData,
            otherAngleDataList: payload.otherAngleData,
            videoPath: payload.otherAngleData[0]?.videoPath,
          },
        },
        totalVideoCount: payload.totalVideoCount,
        angleCount: payload.angleCount,
      };

    case ActionTypes.SET_INTERCUT_VIDEO_LIST_AFTER_DRAG_AND_DROP:
      return {
        ...state,
        interCutVideoList: {
          ...state.interCutVideoList,
          [payload.angleName]: {
            ...state.interCutVideoList[payload.angleName],
            [payload.listName]: payload.data,
          },
        },
      };

    case ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO:
      const { angleName, listName, videoPath, videoDuration } = payload;
      let updatingState2 = JSON.parse(JSON.stringify(state));
      let videoList2 = [
        ...updatingState2.interCutVideoList[angleName][listName],
      ];
      const videoIndex2 = videoList2.findIndex(
        (data) => data.id === payload.id
      );
      videoList2[videoIndex2].videoPath = videoPath;
      videoList2[videoIndex2].videoDuration = videoDuration;
      return { ...updatingState2 };

    // case ActionTypes.RENAME_INTERCUT_VIDEO:
    //   let updatingState = JSON.parse(JSON.stringify(state));
    //   let videoList = [
    //     ...updatingState.interCutVideoList[payload.angleName][payload.listName],
    //   ];
    //   const videoIndex = videoList.findIndex((data) => data.id === payload.id);
    //   videoList[videoIndex].eventMediaCategory = payload.videoName + ".mp4";
    //   return { ...updatingState };

    case ActionTypes.RENAME_INTERCUT_VIDEO:
      const videoCategory = (videoName) => {
        const categories = ["WideAngle", "TightAngle", "EndZoneL", "EndZoneR"];
        for (const category of categories) {
          if (videoName.includes(category)) {
            switch (category) {
              case "WideAngle":
                return {
                  shiftAngle: "wideAngleData",
                  shiftList: "wideAngleDataList",
                };
              case "TightAngle":
                return {
                  shiftAngle: "tightAngleData",
                  shiftList: "tightAngleDataList",
                };
              case "EndZoneL":
                return {
                  shiftAngle: "endZonalData",
                  shiftList: "endZonalDataList",
                };
              case "EndZoneR":
                return {
                  shiftAngle: "endZonarData",
                  shiftList: "endZonarDataList",
                };
              default:
                break;
            }
          }
        }
        return {
          shiftAngle: "otherAngleData",
          shiftList: "otherAngleDataList",
        };
      };

      // Create a deep copy of the current state
      let updatingState = JSON.parse(JSON.stringify(state));

      // Determine the new category for the video
      let { shiftAngle, shiftList } = videoCategory(payload.videoName);

      // Get the current list where the video exists
      let currentVideoList = [
        ...updatingState.interCutVideoList[payload.angleName][payload.listName],
      ];

      // Remove the video from the old category
      currentVideoList = currentVideoList.filter(
        (ele) => ele.id !== payload.id
      );
      // Reassign the updated list back to the original category
      updatingState.interCutVideoList[payload.angleName][payload.listName] =
        currentVideoList;

      // Get the new category list
      let newVideoList = [
        ...updatingState.interCutVideoList[shiftAngle][shiftList],
      ];

      // Find the video to update its eventMediaCategory
      let videoToUpdate = { ...payload }; // Use the payload directly if it contains the full video data
      videoToUpdate.eventMediaCategory = payload.videoName;

      // Push the updated video into the new category list
      newVideoList.push(videoToUpdate);

      // Reassign the new video list back to the new category
      updatingState.interCutVideoList[shiftAngle][shiftList] = newVideoList;

      // Return the updated state
      return { ...updatingState };

    case ActionTypes.RENAME_INTERCUT_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case ActionTypes.DELETE_INTERCUT_VIDEO:
      let updatingState1 = JSON.parse(JSON.stringify(state));
      let videoList1 = [
        ...updatingState1.interCutVideoList[payload.angleName][
          payload.listName
        ],
      ];

      const filteredData = videoList1.filter((data) => data.id !== payload.id);
      updatingState1.interCutVideoList[payload.angleName][payload.listName] =
        filteredData;
      return { ...updatingState1 };

    case ActionTypes.SET_VIDEO_PLAY_INFORMATION:
      return {
        ...state,
        interCutVideoList: {
          ...state.interCutVideoList,
          [payload.angleName]: {
            ...state.interCutVideoList[payload.angleName],
            isPlaying: payload.isPlaying,
            videoPath: payload.videoPath,
            playingIndex: payload.playingIndex,
          },
        },
      };

    default:
      return state;
  }
};
